import React, { useState, useContext } from "react";
import axios from "axios";
import { UserContext } from './UserContext';
import { API_ENDPOINTS } from '../config/api';
import { useToast } from '../hooks/useToast';
import Toast from './Toast';

const CustomerOrderHistory = () => {
    console.log(UserContext, "UserContext")
    const context = useContext(UserContext);
    console.log(context, "context from")
    const { user, restaurant } = context || {};
    const restaurantId = restaurant?._id || user?.id;
    const [contactNumber, setContactNumber] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [orderHistory, setOrderHistory] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { toasts, showToast, removeToast } = useToast();
    const fetchOrderHistory = async () => {
        // At least one field must be provided
        if (!contactNumber.trim() && !customerName.trim()) {
            showToast("Please enter either contact number or customer name to search order history.", 'error');
            return;
        }
        if (!restaurantId) {
            showToast("Restaurant ID not found.", 'error');
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(API_ENDPOINTS.CUSTOMER_ORDER_HISTORY(
                restaurantId,
                contactNumber.trim() || null,
                customerName.trim() || null
            ));
            setOrderHistory(response.data);
            if (response.data.length === 0) {
                showToast("No orders found matching your search criteria.", 'info');
            }
            setLoading(false);
        } catch (err) {
            console.error("Failed to load order history", err);
            const errorMessage = err.response?.data?.message || "Failed to load order history";
            setError(errorMessage);
            showToast(errorMessage, 'error');
            setLoading(false);
        }
    };
    return (
        <>
            <div className="w-full space-y-3">
                <div className="grid gap-2 sm:grid-cols-[minmax(0,1.5fr)_minmax(0,1.5fr)_auto] items-end">
                    <div className="space-y-1">
                        <label className="block text-[10px] font-medium text-stone-600">
                            Contact number
                            <span className="font-normal text-[10px] text-stone-400"> (optional, 10 digits)</span>
                        </label>
                        <div className="flex items-center gap-1.5">
                            <input
                                type="tel"
                                value={contactNumber}
                                maxLength="10"
                                placeholder="Enter 10‑digit number"
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    setContactNumber(value);
                                }}
                                className="border border-stone-300 rounded-lg px-2.5 py-1.5 w-full text-xs focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400"
                            />
                            {contactNumber && (
                                <button
                                    onClick={() => setContactNumber('')}
                                    className="text-[10px] text-stone-500 hover:text-stone-800"
                                    type="button"
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="space-y-1">
                        <label className="block text-[10px] font-medium text-stone-600">
                            Customer name <span className="font-normal text-[10px] text-stone-400">(optional)</span>
                        </label>
                        <div className="flex items-center gap-1.5">
                            <input
                                type="text"
                                value={customerName}
                                placeholder="Enter customer name"
                                onChange={(e) => {
                                    setCustomerName(e.target.value);
                                }}
                                className="border border-stone-300 rounded-lg px-2.5 py-1.5 w-full text-xs focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400"
                            />
                            {customerName && (
                                <button
                                    onClick={() => setCustomerName('')}
                                    className="text-[10px] text-stone-500 hover:text-stone-800"
                                    type="button"
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="flex justify-end sm:justify-start">
                        <button
                            onClick={fetchOrderHistory}
                            disabled={loading}
                            className="px-3 py-1.5 text-xs font-semibold rounded-lg bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50"
                        >
                            {loading ? 'Loading…' : 'Load order history'}
                        </button>
                    </div>
                </div>
                <p className="text-[10px] text-stone-400 italic">
                    Enter at least one field (contact number or customer name) to search.
                </p>

                {orderHistory && orderHistory.length > 0 ? (
                    <div className="relative mt-2">
                        <button
                            onClick={() => {
                                setOrderHistory([]);
                                setContactNumber('');
                                setCustomerName('');
                            }}
                            className="absolute -top-8 right-0 bg-red-500 hover:bg-red-600 text-white w-7 h-7 rounded-full flex items-center justify-center text-xs"
                            title="Close table and clear input"
                        >
                            ×
                        </button>
                        <div className="overflow-x-auto rounded-lg border border-stone-200">
                            <table className="min-w-full text-xs">
                                <thead>
                                    <tr className="bg-stone-50 border-b border-stone-200">
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Order date</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Customer name</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Contact no.</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Table</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Message</th>
                                        <th className="px-3 py-2 text-right whitespace-nowrap">Base total (₹)</th>
                                        <th className="px-3 py-2 text-right whitespace-nowrap">
                                            Tax (₹){' '}
                                            {Number(orderHistory[0]?.taxPercentage) > 0 ? orderHistory[0].taxPercentage : 0}%
                                        </th>
                                        <th className="px-3 py-2 text-right whitespace-nowrap">Service (₹)</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Offer title</th>
                                        <th className="px-3 py-2 text-right whitespace-nowrap">Offer discount (₹)</th>
                                        <th className="px-3 py-2 text-right whitespace-nowrap">Final amount (₹)</th>
                                        <th className="px-3 py-2 text-left whitespace-nowrap">Items ordered</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderHistory.map((order) => {
                                        const tableName =
                                            order.tableId?.displayName ||
                                            order.tableId?.tableName ||
                                            order.tableId?.tableNumber ||
                                            'Unknown table';
                                        return (
                                            <tr key={order._id} className="border-t border-stone-100 hover:bg-stone-50/60">
                                                <td className="px-3 py-2 whitespace-nowrap">
                                                    {new Date(order.orderDate).toLocaleString()}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap">{order.customerName}</td>
                                                <td className="px-3 py-2 whitespace-nowrap">{order.mobileNumber}</td>
                                                <td className="px-3 py-2 whitespace-nowrap">{tableName}</td>
                                                <td className="px-3 py-2 max-w-xs truncate">
                                                    {order.message ? order.message : '-'}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap text-right">
                                                    {order.totalAmount.toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap text-right">
                                                    {order.taxAmount
                                                        ? order.taxAmount.toFixed(2)
                                                        : (
                                                              (order.totalAmount * (order.taxPercentage || 0)) /
                                                              100
                                                          ).toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap text-right">
                                                    {order.serviceAmount && order.serviceAmount > 0
                                                        ? order.serviceAmount.toFixed(2)
                                                        : 0}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap">
                                                    {order.appliedOffer ? order.appliedOffer.title : '-'}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap text-right">
                                                    {order.offerDiscount ? order.offerDiscount.toFixed(2) : '-'}
                                                </td>
                                                <td className="px-3 py-2 whitespace-nowrap text-right font-semibold">
                                                    {order.finalAmount.toFixed(2)}
                                                </td>
                                                <td className="px-3 py-2 max-w-xs">
                                                    {order.items.map((item, index) => (
                                                        <div key={index} className="text-[11px] mb-0.5">
                                                            {item.name} (x{item.quantity})
                                                        </div>
                                                    ))}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <p className="text-[11px] text-stone-400">No order history available.</p>
                )}

                {/* Toast Notifications */}
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        type={toast.type}
                        duration={toast.duration}
                        onClose={() => removeToast(toast.id)}
                    />
                ))}
            </div>
        </>
    );
}

export default CustomerOrderHistory;